import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

interface Props {
  readonly content?: string;
  readonly size?: number;
}

export const QrCodeImage: React.FC<Props> = (props: Props): React.ReactElement => {
  const { content, size = 200 } = props;
  const theme = useTheme();

  if (!content || content === '') {
    return (
      <Box
        width={size}
        height={size}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="custom.LightGray"
        sx={animation}
      />
    );
  } else {
    return (
      <QRCodeSVG
        value={content}
        size={size}
        fgColor={theme.palette.text.primary}
        bgColor={theme.palette.background.paper}
      />
    );
  }
};

const animation = {
  animation: 'pulse 1.5s ease-in-out infinite',
  '@keyframes pulse': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.4 },
    '100%': { opacity: 1 },
  },
};
